import React from 'react'
import { Switch } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { SettingSection, SettingsSectionParams } from './form.props'
import { extractFormData, getFileFromBlobUrl } from 'src/core/helpers'
import { updateIntegrationLogo, updateIntegrationWhiteLabel } from 'src/features'
import { CustomImageInput, CustomColorInput, CustomFileInput } from 'src/components'

export const lookFeelFields = ({
  t,
  formValues,
  setFormValues,
  whiteLabel,
  dispatch,
  integrationId,
  integration_logo,
  currency_code
} : SettingsSectionParams ): SettingSection[] => [

  { // Certificate Logo
    isVisible: true,
    labels: {
      title: t('Whitelabel.Certificate'),
      subtitle: t('Whitelabel.CertificateLabel')
    },
    form: {
      component: CustomImageInput,
      props: {
        name: 'integration_logo',
        value: integration_logo,
        addResolutionValdiation: false,
        onChangeFileUrl: (value: string) => {
          setFormValues({ ...formValues, integration_logo: value })
          dispatch(updateIntegrationLogo(integrationId, value, currency_code))
        },
      }
    }
  },

  { // Flag Embbeded
    isVisible: whiteLabel,
    rowClassName: 'mt-5',
    rowXs1: 19,
    rowXs2: 5,
    labels: {
      title: t('Whitelabel.Embedded'),
      subtitle: t('Whitelabel.EmbeddedLabel')
    },
    form: {
      component: Switch,
      props: {
        checked: formValues?.embedded,
        checkedChildren: <CheckOutlined />,
        unCheckedChildren: <CloseOutlined />,
        onChange: (value: boolean) => {
          setFormValues({ ...formValues, embedded: value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { embedded: value }))
        },
      }
    }
  },

  { // Header Logo
    isVisible: whiteLabel && !formValues?.embedded,
    rowClassName: 'mb-5',
    labels: {
      title: t('Whitelabel.Header'),
      subtitle: t('Whitelabel.HeaderLabel')
    },
    form: {
      component: CustomImageInput,
      props: {
        name: 'logo',
        value: formValues?.logo || whiteLabel?.logo,
        addResolutionValdiation: false,
        onChangeFileUrl: async (value: string) => {
          setFormValues({ ...formValues, logo: value })
          const filesData = { logo: value ?  await getFileFromBlobUrl(value) : '' }
          const payload = extractFormData(filesData)
          dispatch(updateIntegrationWhiteLabel(integrationId, payload))
        },
      }
    }
  },

  { // Background Image
    isVisible: whiteLabel,
    rowClassName: 'mb-5',
    labels: {
      title: t('Whitelabel.Background'),
      subtitle: t('Whitelabel.BackgroundLabel')
    },
    form: {
      component: CustomImageInput,
      props: {
        name: 'background_image',
        value: formValues?.background_image || whiteLabel?.background_image,
        onChangeFileUrl: async (value: string) => {
          setFormValues({ ...formValues, background_image: value })
          const filesData = { background_image: value ?  await getFileFromBlobUrl(value) : '' }
          const payload = extractFormData(filesData)
          dispatch(updateIntegrationWhiteLabel(integrationId, payload))
        },
      }
    }
  },

  { // Primary Color
    isVisible: whiteLabel,
    rowClassName: 'mb-2 mt-2',
    rowXs1: 17,
    rowXs2: 7,
    labels: {
      title: t('Whitelabel.PrimaryColor'),
      subtitle: t('Whitelabel.PrimaryColorLabel')
    },
    form: {
      component: CustomColorInput,
      props: {
        value: formValues?.primary_color,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValues({ ...formValues, primary_color: e.target.value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { primary_color: e.target.value }))
        },
      }
    }
  },

  { // Secondary Color
    isVisible: whiteLabel,
    rowXs1: 17,
    rowXs2: 7,
    labels: {
      title: t('Whitelabel.SecondaryColor'),
      subtitle: t('Whitelabel.SecondaryColorLabel')
    },
    form: {
      component: CustomColorInput,
      props: {
        value: formValues?.secondary_color,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValues({ ...formValues, secondary_color: e.target.value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { secondary_color: e.target.value }))
        },
      }
    }
  },


  { // Font
    isVisible: whiteLabel,
    rowClassName: 'mt-5',
    rowLg1: 11,
    rowLg2: 12,
    firstColClassName: 'whitelabel-font-margin',
    labels: {
      title: t('Whitelabel.FontFile'),
      subtitle: t('Whitelabel.FontFileLabel')
    },
    form: {
      component: CustomFileInput,
      props: {
        name: 'font',
        value: formValues?.font || whiteLabel?.font,
        allowedExtensions: 'font/ttf, font/otf',
        onChangeFileUrl: async (value: string) => {
          setFormValues({ ...formValues, font: value })
          const filesData = { font: value ?  await getFileFromBlobUrl(value) : '' }
          const payload = extractFormData(filesData)
          dispatch(updateIntegrationWhiteLabel(integrationId, payload))
        },
      }
    }
  },

  { // Welcome Text Color
    isVisible: whiteLabel,
    rowXs1: 17,
    rowXs2: 7,
    labels: {
      title: t('Whitelabel.WelcomeTextColor'),
      subtitle: t('Whitelabel.WelcomeTextColorLabel')
    },
    form: {
      component: CustomColorInput,
      props: {
        value: formValues?.welcome_text_color,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValues({ ...formValues, welcome_text_color: e.target.value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { welcome_text_color: e.target.value }))
        },
      }
    }
  },

  { // Thank You Background image
    isVisible: whiteLabel,
    rowClassName: 'mb-5',
    labels: {
      title: t('Whitelabel.ThankImage'),
      subtitle: t('Whitelabel.AddImage')
    },
    form: {
      component: CustomImageInput,
      props: {
        value: formValues?.thank_you_bg || whiteLabel?.thank_you_bg,
        onChangeFileUrl: async (value: string) => {
          setFormValues({ ...formValues, thank_you_bg: value })
          const filesData = { thank_you_bg: value ?  await getFileFromBlobUrl(value) : '' }
          const payload = extractFormData(filesData)
          dispatch(updateIntegrationWhiteLabel(integrationId, payload))
        },
      }
    }
  },
]
